import { render, staticRenderFns } from "./unbind.vue?vue&type=template&id=66c9a81a&"
import script from "./unbind.vue?vue&type=script&lang=js&"
export * from "./unbind.vue?vue&type=script&lang=js&"
import style0 from "./unbind.vue?vue&type=style&index=0&id=66c9a81a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports